/* eslint-disable max-len */

import React, { useMemo } from "react"

import { Controller } from 'react-hook-form'

import { Accordion, Toggle } from "@cgtrader/triangle-ui/dist/src/ssr-index"
import { bool, func, object } from "prop-types"

import useUseCaseTranslate from 'Pods/LazyLoaded/UseCaseAreaSidebar/hooks/useUseCaseTranslate'
import CustomSelect from "Pods/Shared/CustomSelect/CustomSelect"

import { TECHNOLOGY_OPTIONS, PRINT_TIME_OPTIONS, translateOptions } from "../../../../Utils/Data"
import SlicerFileUploadSection from "../SlicerFileUploadSection/SlicerFileUploadSection"

function TechnicalDetailsSection({
  control,
  slicerFile = null,
  handleSlicerFileSelect,
  handleSlicerFileRemove,
  showNotification,
  userHavePermissions,
}) {
  const { t } = useUseCaseTranslate()
  const technologyOptions = useMemo(() => translateOptions(TECHNOLOGY_OPTIONS, 'technology', t), [t])
  const printTimeOptions = useMemo(() => translateOptions(PRINT_TIME_OPTIONS, 'printTime', t), [t])

  const label = (
    <span className="use-cases-area__label use-cases-area__label--technical-details cgt-body-base-semibold">
      {t('form.technicalDetails')}
    </span>
  )

  const content = (
    <>
      <SlicerFileUploadSection
        slicerFile={slicerFile}
        onSelect={handleSlicerFileSelect}
        onRemove={handleSlicerFileRemove}
        disabled={!userHavePermissions}
        onShowNotification={showNotification}
      />

      <div className="use-cases-area__form-row">
        <div className="use-cases-area__select-container use-cases-area__form-column use-cases-area__form-column--stacked-mobile">
          <span className="use-cases-area__label cgt-body-base-semibold cgt-mb-4">
            {t('form.technologyLabel')}
          </span>
          <Controller
            name="technology"
            control={control}
            render={({ field }) => (
              <CustomSelect
                {...field}
                options={technologyOptions}
                placeholder={t('form.technologyPlaceholder')}
                isDisabled={!userHavePermissions}
                className="use-cases-area__select"
                isClearable
              />
            )}
          />
        </div>

        <div className="use-cases-area__select-container use-cases-area__form-column use-cases-area__form-column--stacked-mobile">
          <span className="use-cases-area__label cgt-body-base-semibold cgt-mb-4">
            {t('form.printTimeLabel')}
          </span>
          <Controller
            name="printTime"
            control={control}
            render={({ field }) => (
              <CustomSelect
                {...field}
                options={printTimeOptions}
                placeholder={t('form.printTimePlaceholder')}
                isDisabled={!userHavePermissions}
                className="use-cases-area__select"
                isClearable
              />
            )}
          />
        </div>
      </div>

      <div className="use-cases-area__toggle-container">
        <span className="use-cases-area__label cgt-body-base-semibold">
          {t('form.supportsUsed')}
        </span>
        <Controller
          name="usedSupport"
          control={control}
          render={({ field: { value, onChange } }) => (
            <Toggle
              id="supports-used-toggle"
              checked={value}
              onChange={onChange}
              disabled={!userHavePermissions}
            />
          )}
        />
      </div>
    </>
  )

  const items = [{
    id: 'technical-details',
    label,
    content,
    contentClassName: 'use-cases-area__technical-details-content',
  }]

  return (
    <Accordion
      className="use-cases-area__technical-details"
      items={items}
    />
  )
}

TechnicalDetailsSection.propTypes = {
  control: object.isRequired,
  slicerFile: object,
  handleSlicerFileSelect: func.isRequired,
  handleSlicerFileRemove: func.isRequired,
  showNotification: func.isRequired,
  userHavePermissions: bool.isRequired,
}

export default TechnicalDetailsSection
